import { render, staticRenderFns } from "./VoucherBatchList.vue?vue&type=template&id=315b6534&scoped=true&"
import script from "./VoucherBatchList.vue?vue&type=script&lang=js&"
export * from "./VoucherBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b6534",
  null
  
)

export default component.exports